<script>
    import OPTS from '../options';
    import { query } from '../stores';

    export let results = [];

    const levels = {
        fonds: "fondo",
        collection: "collezione/raccolta",
        subfonds: "subfondo",
        subseries: "sottoserie",
        series: "serie",
        file: "unità archivistica",
        item: "unità documentaria",
    }
    const otherlevels = {
        subfile: "sottounità archivistica",
        container: "unità di conservazione",
    }

    function title(id) {
        if (id.startsWith("IT-PRI-ST0001")) {
            return "Fondo Primoli";
        } else if (id.startsWith("IT-PRI-ST0002")) {
            return "Fondo Trompeo";
        } else if (id.startsWith("IT-PRI-ST0003")) {
            return "Fondo M. Praz";
        }

        return "";
    }

    function levelText(level, otherlevel) {
        if (level === 'otherlevel')
            return otherlevels[otherlevel];

        return levels[level];
    }
</script>

<ul class="list-results-doc">
    {#each results as doc, i (doc.id)}
        <li>
            <a href={`${OPTS.base_url}archivio/storico/${doc.id}?ssid=${OPTS.ssid}`}>
                {#if $query.active === 'all' || OPTS.mode_multi}
                    <span>{title(doc.id)} - </span>
                {/if}
                <span>{levelText(doc.c_level_string, doc.c_otherlevel_string)}</span>
                <p>
                    <strong>{doc.c_did_unittitle_encodinganalog_ISAD_312_title_string}</strong> <i>{doc.c_did_unittitle_encodinganalog_ISAD_312_title_unitdate_encodinganalog_ISAD_313_dates_string || ''}</i>
                </p>
            </a>
        </li>
    {/each}
</ul>

<style>
    .list-results-doc li a p {
        font-weight: normal;
    }
</style>